import styled from 'styled-components'

export const LeftContainer = styled.div`
  min-width: 400px;
  flex: 1;
  overflow-y: scroll;
  width: 100%;
  height: 100%;
  min-height: calc(100% + 5px);
`

export const CenterContainer = styled.div`
  padding-top: 40px;
  flex: auto;
  height: 100%;
  width: 100%;
`

export const RightContainer = styled.div`
  padding-top: 40px;
  max-width: 280px;
  /* flex: 1; */
  width: 100%;
  height: 100%;
`

export const StrongTitle = styled.strong`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-weight: ${({ theme }) => theme.font.bold};
  font-size: ${({ theme }) => theme.ds.typography.size.medium};
  line-height: 28px;
  margin-right: 20px;
`

export const SubTitle = styled.label`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.bold};
  line-height: 28px;
`

export const TextDescription = styled.span`
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.normal};
  /* margin-bottom: 20px; */
`

export const TitleEligibility = styled.p<any>`
  color: ${({ theme, color }) => color || theme.ds.colors.primary600};
  font-weight: ${({ theme }) => theme.font.semiBold};
  margin-bottom: 5px;
  display: flex;
  place-content: center;
  align-items: center;
  gap: 4px;

  svg {
    path {
      fill: ${({ theme, color }) => color || theme.ds.colors.primary600};
    }
  }
`

export const TextStrong = styled.p`
  color: ${({ theme }) => theme.ds.colors.neutral900};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.semiBold};
  /* margin-bottom: 20px; */
`

export const TextLight = styled.p`
  color: ${({ theme }) => theme.ds.colors.neutral800};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.semiBold};
  margin-top: 20px;
`

export const RadioContainer = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 30px;
`

export const Separator = styled.div`
  width: 1px;
  /* height: 572px; */
  height: 100%;
  margin: 0 18px;
  background-color: ${({ theme }) => theme.ds.colors.neutral100};
  justify-self: flex-end;
  align-self: flex-end;
`

export const PatientControlPanel = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 30px;
`

export const ManualStatusInfo = styled.p`
  color: ${({ theme }) => theme.ds.colors.neutral600};
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  font-weight: ${({ theme }) => theme.ds.typography.weight.semiBold};
  margin-bottom: 10px;
`

export const ButtonContainer = styled.p`
  margin: 25px 0;
`

export const CustomDescription = styled.p`
  font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
`
